import { Routes, Route, type Location } from 'react-router-dom';
import { Home } from './Home';
import { MovieDetail } from './MovieDetail';
import { Watch } from './Watch';
import { Collection } from './Collection';
import { MyList } from './MyList';
import { Search } from './Search';

export function MovieflixRoutes({ location }: { location?: Partial<Location> | string }) {
  return (
    <Routes location={location}>
      <Route path="/movieflix" element={<Home />} />
      <Route path="/movieflix/movie/:id" element={<MovieDetail />} />
      <Route path="/movieflix/watch/:id" element={<Watch />} />
      <Route path="/movieflix/collection/:slug" element={<Collection />} />
      <Route path="/movieflix/my-list" element={<MyList />} />
      <Route path="/movieflix/search" element={<Search />} />
    </Routes>
  );
}
